import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';

import { useActiveScreen } from '@/hooks/useActiveScreen';
import { AccountsDashboardScreen } from '@/screens/accounts-dashboard/AccountsDashboard.screen';
import { OrganizationsDashboardScreen } from '@/screens/organizations-dashboard/OrganizationsDashboard.screen';
import { ScreensEnum } from '@/store/app/app.types';

export const AccountsRoute = () => {
  useActiveScreen(ScreensEnum.accounts);
  const [useOrganizationsEndpointForCompaniesList] = useFeature<boolean>(
    FeatureFlags.UseOrganizationsEndpointForCompaniesList,
    false,
  );

  return (
    <Routes>
      <Route
        index
        element={
          useOrganizationsEndpointForCompaniesList ? <OrganizationsDashboardScreen /> : <AccountsDashboardScreen />
        }
      />
    </Routes>
  );
};
